module.exports = __webpack_public_path__ + "static/img/account.12bd405.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/account.png
// module id = t8S9
// module chunks = 1